const getDisplayRating = rating => {
    if (rating) {
        let decimals = decimalPlaces(rating);
        if (decimals === 0) decimals = 1;
        return rating.toFixed(decimals);
    }
};

const decimalPlaces = num => {
    var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0) -
            // Adjust for scientific notation.
            (match[2] ? +match[2] : 0)
    );
};

export default {
    getDisplayRating
};
